import { Controller } from 'stimulus'

export default class FlashMessageController extends Controller {
  static targets = ['message', 'closeBtn']

  connect() {
    $(this.messageTarget).transition('fly up', this.autoClose)
  }

  close() {
    $(this.closeBtnTarget)
      .closest('.flash-message')
      .transition('fly up', this.destroy)
    ;
  }

  destroy() {
    $(this).remove()
  }

  autoClose() {
    window.setTimeout(() => {
      $(this).transition('fly up')
    }, 5000)
  }
}
